import { lazy } from 'react';

import { RoutesConfigType } from '@src/lib/types';

const ComingSoon = lazy(() => import('@src/screens/ComingSoon'));

const cafeRoutes: Array<RoutesConfigType> = [{ path: '/cafe', component: ComingSoon, layout: 'private' }];

export default cafeRoutes;
